/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  StandardResponse,
  TrackGet200Response,
  TrackPost,
  TrackResult,
} from '../models';
import {
    StandardResponseFromJSON,
    StandardResponseToJSON,
    TrackGet200ResponseFromJSON,
    TrackGet200ResponseToJSON,
    TrackPostFromJSON,
    TrackPostToJSON,
    TrackResultFromJSON,
    TrackResultToJSON,
} from '../models';

export interface ShipTrackIdDeleteRequest {
    id: number;
}

export interface ShipTrackIdGetRequest {
    id: number;
    track?: number;
}

export interface ShipTrackIdPutRequest {
    id: number;
    json: TrackPost;
}

export interface ShipTrackPostRequest {
    json: TrackPost;
}

/**
 * 
 */
export class TrackApi extends runtime.BaseAPI {

    /**
     * Stop and delete a track.
     * Stop and delete a track.
     */
    async shipTrackIdDeleteRaw(requestParameters: ShipTrackIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StandardResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling shipTrackIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/track/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StandardResponseFromJSON(jsonValue));
    }

    /**
     * Stop and delete a track.
     * Stop and delete a track.
     */
    async shipTrackIdDelete(requestParameters: ShipTrackIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StandardResponse> {
        const response = await this.shipTrackIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the current status of the track of the ship towards the destination. Return the current track and ETA. Call /track/{ID} DELETE to stop and delete the track.
     * Get status of a track of a ship towards a predefined destination
     */
    async shipTrackIdGetRaw(requestParameters: ShipTrackIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrackResult>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling shipTrackIdGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.track !== undefined) {
            queryParameters['track'] = requestParameters.track;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/track/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TrackResultFromJSON(jsonValue));
    }

    /**
     * Get the current status of the track of the ship towards the destination. Return the current track and ETA. Call /track/{ID} DELETE to stop and delete the track.
     * Get status of a track of a ship towards a predefined destination
     */
    async shipTrackIdGet(requestParameters: ShipTrackIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrackResult> {
        const response = await this.shipTrackIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the ERP information for the arrival with any information available from the ERP system.
     * Update arrival with ERP information
     */
    async shipTrackIdPutRaw(requestParameters: ShipTrackIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling shipTrackIdPut.');
        }

        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling shipTrackIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/track/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TrackPostToJSON(requestParameters.json),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update the ERP information for the arrival with any information available from the ERP system.
     * Update arrival with ERP information
     */
    async shipTrackIdPut(requestParameters: ShipTrackIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.shipTrackIdPutRaw(requestParameters, initOverrides);
    }

    /**
     * Start a track of a ship towards a predefined destination. Perform an initial route calculation. Will then keep track of the ship until it has reached its destination. By polling /ship/track/{ID} GET the current status can be retrieved. Call /ship/track/{ID} DELETE to stop and delete the track.<br> If the ship cannot be found then an error code is returned unless \"source.ship.create\" = true.
     * Start a track of a ship towards a predefined destination
     */
    async shipTrackPostRaw(requestParameters: ShipTrackPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling shipTrackPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/track`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TrackPostToJSON(requestParameters.json),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Start a track of a ship towards a predefined destination. Perform an initial route calculation. Will then keep track of the ship until it has reached its destination. By polling /ship/track/{ID} GET the current status can be retrieved. Call /ship/track/{ID} DELETE to stop and delete the track.<br> If the ship cannot be found then an error code is returned unless \"source.ship.create\" = true.
     * Start a track of a ship towards a predefined destination
     */
    async shipTrackPost(requestParameters: ShipTrackPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.shipTrackPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the current status of the track of all ship towards the destinations. Return the current track and ETA. Use this to get all active tracks. Call /ship/track/{ID} DELETE to stop and delete the track.
     * Get status of a track for all ships towards predefined destinations
     */
    async trackGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrackGet200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/track`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TrackGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Get the current status of the track of all ship towards the destinations. Return the current track and ETA. Use this to get all active tracks. Call /ship/track/{ID} DELETE to stop and delete the track.
     * Get status of a track for all ships towards predefined destinations
     */
    async trackGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrackGet200Response> {
        const response = await this.trackGetRaw(initOverrides);
        return await response.value();
    }

}
